"use client";

import useSWR from "swr";
import { getPage } from "../sanity/client";
import CustomContent from "../components/customContent";
import styles from "../layout.module.css";

export default function AnnualReport() {
  const { data: content } = useSWR("page-annual-report", () =>
    getPage("annual-report").then((r: any) => r[0].content)
  );

  return (
    <>
      <h1 className="font-bold text-3xl mb-4">Annual Report</h1>

      <CustomContent value={content} />

      <a
        className={styles.donateButton}
        target="_blank"
        rel="noreferrer"
        href="https://www.zeffy.com/en-US/donation-form/scribbles-2026-fundraising-drive"
      >
        Donate to Scribble
      </a>

      <div style={{ marginBottom: "100px" }} />
    </>
  );
}
